import React, { FC, useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { FormLayout } from '../../../../shared/kiosk';
import { useTranslation } from '../../../translations';
import { Fetcher, useFetcher } from '../../../utils';
import { captureError } from '../../../utils/errorHandling';
import { ExpressEditorComponentInner } from '../expressEditor';
import { KioskEditorConfiguration, OptionContextProps } from '../expressEditor/OptionContext';

const VolunteerFormEditorConfig: KioskEditorConfiguration = {
  multiplePages: false,
  allowCss: false,
  formTypes: [
    'markdown',
    'divider',
    'simpleLinkedTerms',
    'volunteerContact',
    'volunteerOption',
    'volunteerDepartments',
  ],
};

export const VolunteerFormExpressEditor: FC = () => {
  const [config, setConfig] = useState<OptionContextProps>(() => ({
    config: VolunteerFormEditorConfig,
    options: [],
  }));

  const { ts } = useTranslation();

  const fetch = useFetcher(async () => {
    // Get volunteer options
    const options = await api.getOptions('volunteer');
    setConfig((old) => ({ ...old, options }));

    const pageLayout = await api.getVolunteerFormLayout();

    const defaultLayout: FormLayout = {
      finalPage: {
        id: 'final',
        name: 'Confirmation',
        sections: [],
      },
      footer: '',
      header: '',
      pages: [pageLayout],
      paymentOptions: {
        showPaymentScreen: true,
        markdown: '',
      },
      stylesheet: '',
      title: 'Express Editor for Volunteers',
      disableBootstrap: false,
    };

    return { layout: defaultLayout };
  }, []);

  const save = useCallback(
    async (layout: FormLayout) => {
      try {
        await api.updateVolunteerFormLayout(layout.pages[0]!);
        toast.success(ts('saved'));
      } catch (error) {
        captureError(error as Error);
      }
    },
    [ts],
  );

  if (!fetch.success) {
    return <Fetcher result={fetch} />;
  }

  return (
    <ExpressEditorComponentInner
      backLink="/housekeeping/volunteers/settings"
      config={config}
      hideBeta
      initialLayout={fetch.data.layout}
      save={save}
    />
  );
};
